export default __webpack_public_path__ + "0de4266d467db70a97a60d356f831d10.png";